import type { UserPermissions } from "common/types";

import LinkedInAccounts from "./accounts/components/LinkedInAccounts";
import Campaigns from "./campaigns/components/Campaigns";
import Home from "./home/components/Home";
import Inbox from "./inbox/components/Inbox";
import Integrations from "./integrations/components/Integrations";
import Invitation from "./invitation/Invitation";
import Leads from "./leads/components/Leads";
import Notifications from "./notifications/components/Notifications";
import Templates from "./templates/components/Templates";
import WorkspaceOnboarding from "./workspace-onboarding";
import WorkspaceSettings from "./workspace-settings/components/WorkspaceSettings";
import Workspaces from "./workspaces/components/Workspaces";

import type { JSX } from "react";

interface WorkspaceRoute {
  path: string;
  component: JSX.Element;
  visibleForPermissions?: UserPermissions;
}

const baseRoutes = [
  {
    path: "workspaces",
    component: <Workspaces />,
  },
  {
    path: "invitations/:inviteToken",
    component: <Invitation />,
  },
];

const workspaceRoutes: WorkspaceRoute[] = [
  {
    path: "home",
    component: <Home />,
  },
  {
    path: "campaigns/*",
    component: <Campaigns />,
    visibleForPermissions: ["campaigns_full", "campaigns_limited"],
  },
  {
    path: "leads/*",
    component: <Leads />,
    visibleForPermissions: ["leads_full"],
  },
  {
    path: "templates/*",
    component: <Templates />,
    visibleForPermissions: ["templates_full", "templates_limited"],
  },
  {
    path: "inbox",
    component: <Inbox />,
    visibleForPermissions: ["inbox_full", "inbox_limited"],
  },
  {
    path: "settings/*",
    component: <WorkspaceSettings />,
  },
  {
    path: "notifications",
    component: <Notifications />,
  },
  {
    path: "onboarding",
    component: <WorkspaceOnboarding />,
  },
  {
    path: "accounts/*",
    component: <LinkedInAccounts />,
    visibleForPermissions: ["accounts_full", "accounts_limited"],
  },
  {
    path: "integrations",
    component: <Integrations />,
    visibleForPermissions: ["integrations_full"],
  },
] as const;

export { workspaceRoutes, baseRoutes };
